import zip from '@/js/forms/zip'
import validates from '@/js/forms/validate'
import assessments from '@/js/forms/assessment'
import estates from '@/js/forms/estate'
import recaptcha from '@/js/forms/recaptcha'

const forms = () => {
    zip()
    validates()
    assessments()
    estates()
    recaptcha()
}

export default forms